var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2435_146010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.44 24.88C20.6536 24.88 24.88 20.6536 24.88 15.44C24.88 10.2264 20.6536 6 15.44 6C10.2264 6 6 10.2264 6 15.44C6 20.6536 10.2264 24.88 15.44 24.88Z",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1104 22.11L24.6704 24.67",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8297 32.69C33.7197 32.94 33.5797 33.17 33.3697 33.37C32.5197 34.21 31.1597 34.21 30.3197 33.37L24.6697 27.72C23.8197 26.87 23.8197 25.51 24.6697 24.67C24.8697 24.47 25.1097 24.31 25.3497 24.21C25.6197 24.1 25.9097 24.04 26.1897 24.04C26.7497 24.04 27.2997 24.25 27.7197 24.67L33.3697 30.32C34.0097 30.96 34.1597 31.9 33.8297 32.69Z",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6104 19.76V17.57",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1699 19.76V16.14",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7305 19.76V13.2",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.29 19.76V11.21",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2435_146010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/Monitor.c41719c362ba8770f0a8a82bf5e1b709.svg";
export { ForwardRef as ReactComponent };